import { mapPostPreviewFields } from '@/adapters/posts'
import { normalizeFilterParam } from '@/shared/utils'
import { directusClient, imageFields, readItems } from '@/shared/utils/directus'

export interface GetPostsParams {
  locale?: string
  categoryId?: string | number
  page?: number
  limit?: number
  dateRange?: [string, string]
  authorId?: string | number | string[] | number[]
}

export default async function getPosts({
  locale = 'ru-RU',
  categoryId,
  page = 1,
  limit = 12,
  dateRange,
  authorId,
}: GetPostsParams = {}) {
  const collectionName = 'posts'

  const authorIdNormalized = normalizeFilterParam(authorId)

  const filter = {
    translations: { languages_code: { _eq: locale } },
    category: categoryId,
    date_published:
      Array.isArray(dateRange) && dateRange.filter(el => el).length === 2 ? { _between: dateRange } : undefined,
    authors: authorIdNormalized.length ? { person: { id: { _in: authorIdNormalized } } } : undefined,
  }

  try {
    const itemsRaw = await directusClient.request<Directus.PostPreview[]>(
      readItems(collectionName, {
        sort: ['-date_published'],
        page,
        limit,
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
          category: {
            translations: { _filter: { languages_code: { _eq: locale } } },
          },
          author: {
            translations: { _filter: { languages_code: { _eq: locale } } },
          },
        },
        fields: [
          'id',
          'type',
          'slug',
          'external_url',
          'external_url_en',
          'date_published',
          {
            translations: ['title'],
            category: ['id', 'slug', 'color', { translations: ['name', 'name_plural'] }],
            image_preview: imageFields,
            image_preview_en: imageFields,
          },
        ],
      })
    )

    const aggregateCount = await directusClient.request<{ count: number }[]>(
      readItems(collectionName, {
        filter,
        aggregate: { count: '*' },
      })
    )

    const items = itemsRaw?.map(item => {
      return mapPostPreviewFields(item, locale)
    })

    return {
      items,
      page,
      limit,
      total: aggregateCount?.[0]?.count || 0,
    }
  } catch (error) {
    return {
      items: [],
      page,
      limit,
      total: 0,
    }
  }
}
